import { render, staticRenderFns } from "./VodaContractPopup.vue?vue&type=template&id=2642a951"
import script from "./VodaContractPopup.vue?vue&type=script&lang=js"
export * from "./VodaContractPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports